export function filterUndefined<T>(array: T[] | undefined): T[] {
  if (array === undefined) {
    return []
  }

  return array.filter((value: T | undefined): value is T => value !== undefined)
}
